import { render } from "./footerCpn.vue?vue&type=template&id=0d986ce4&scoped=true"
const script = {}

import "./footerCpn.vue?vue&type=style&index=0&id=0d986ce4&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d986ce4"]])

export default __exports__